import { toast } from "sonner";

// Partage natif (iPhone/Android) avec repli presse-papiers + toast.
// Si `image` est fournie (URL de la carte), elle est jointe au partage quand
// l'appareil le permet : le message contient alors l'image ET le lien.
export async function shareOrCopy({ title, text, url, image, copiedMsg = "Lien copié — collez-le dans votre message" }) {
  try {
    if (image && navigator.canShare) {
      try {
        const blob = await fetch(image).then((r) => r.blob());
        const file = new File([blob], "bistroquet.jpg", { type: "image/jpeg" });
        if (navigator.canShare({ files: [file] })) {
          await navigator.share({ title, text: `${text}\n${url}`, files: [file] });
          return "shared";
        }
      } catch (err) {
        if (err?.name === "AbortError") return "aborted";
        // image injoignable ou partage de fichier refusé : on retombe sur le lien seul
      }
    }
    if (navigator.share) {
      await navigator.share({ title, text, url });
      return "shared";
    }
    throw new Error("no-share-api");
  } catch (err) {
    if (err?.name === "AbortError") return "aborted"; // l'utilisateur a fermé la feuille de partage
    try {
      await navigator.clipboard.writeText(url);
      toast.success(copiedMsg);
      return "copied";
    } catch {
      toast.error("Copie impossible — maintenez le lien pour le copier.");
      return "failed";
    }
  }
}
